import { createFileRoute } from '@tanstack/react-router';
import { Header, Footer } from '@/components/marketing';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/blog')({
  component: BlogPage,
});

const blogPosts = [
  {
    title: 'Announcing Core-Forge 2.0: A Multi-Product Platform',
    description: 'Today we are launching the next evolution of ForgeNetwork.',
    category: 'Announcements',
    date: 'December 4, 2024',
    readTime: '5 min read',
  },
  {
    title: 'Best Practices for AI-Powered Code Analysis',
    description: 'Learn how to get the most out of automated code analysis tools.',
    category: 'Engineering',
    date: 'November 28, 2024',
    readTime: '8 min read',
  },
];

function BlogPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <Badge variant="secondary" className="mb-4">Blog</Badge>
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4">Insights & Updates</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              News, tutorials, and deep dives from the ForgeNetwork team.
            </p>
          </div>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 max-w-5xl mx-auto">
            {blogPosts.map((post) => (
              <Card key={post.title} className="hover:shadow-lg transition-shadow">
                <CardHeader>
                  <Badge variant="outline" className="w-fit mb-2">{post.category}</Badge>
                  <CardTitle className="text-lg line-clamp-2">{post.title}</CardTitle>
                  <CardDescription className="line-clamp-2">{post.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="flex justify-between text-sm text-muted-foreground">
                    <span>{post.date}</span>
                    <span>{post.readTime}</span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
